import React, { useState } from 'react';
import { Checkbox } from '../../ui/checkbox';

const PostalOnlySection = ({
  formData,
  handleInputChange,
  isDark,
  isEmbedded = false
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const isPostalSelected = formData.sending_preference === 'postal';
  const isPostalOnlyChecked = formData.delivery_preference === 'postal_only';
  const isDisabled = !isPostalSelected;

  const handleCheckboxChange = (checked) => {
    if (isDisabled) return;
    handleInputChange('delivery_preference', checked ? 'postal_only' : '');
  };

  const content = (
    <>
      {/* Checkbox with tooltip */}
      <div
        className="relative flex items-center gap-[8px]"
        onMouseEnter={() => isDisabled && setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <Checkbox
          id="delivery-preference-postal-only"
          checked={isPostalOnlyChecked}
          onCheckedChange={handleCheckboxChange}
          disabled={isDisabled}
          isDark={isDark}
        />
        <label
          htmlFor="delivery-preference-postal-only"
          className={`text-[16px] font-normal transition-colors duration-200 ${
            isDisabled
              ? `cursor-not-allowed ${isDark ? 'text-[#666666]' : 'text-[#a0a0a0]'}`
              : `cursor-pointer ${isDark ? 'text-white' : 'text-[#072837]'}`
          }`}
        >
          Send to recipients who elected post only
        </label>

        {/* Tooltip when disabled */}
        {formData.sending_preference !== 'postal' && showTooltip && (
          <div className={`absolute left-0 top-full mt-[4px] px-[12px] py-[8px] rounded-[8px] text-[12px] font-normal whitespace-nowrap transition-all duration-200 z-[100] shadow-lg ${
            isDark ? 'bg-[#292929] text-white' : 'bg-[#333333] text-white'
          }`}>
            Please select "Postal" sending preference to enable this option
            <div className={`absolute left-[20px] bottom-full w-0 h-0 border-l-[6px] border-r-[6px] border-b-[6px] border-transparent ${
              isDark ? 'border-b-[#292929]' : 'border-b-[#333333]'
            }`}></div>
          </div>
        )}
      </div>

      {/* Helper text */}
      <div className={`text-[14px] font-normal transition-colors duration-200 ${
        isDark ? 'text-[#b3b3b3]' : 'text-[#686868]'
      }`}>
        If you are sending to all owners via email (Front), however you still need to deliver the correspondence to those who elect Post, please use this option.
      </div>
    </>
  );

  if (isEmbedded) {
    return content;
  }

  return (
    <div className={`border-none rounded-[16px] p-[20px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.11)] w-full max-w-[822px] flex flex-col gap-[16px] transition-colors duration-200 ${
      isDark ? 'bg-[#000000]' : 'bg-white'
    }`}>
      {/* Header */}
      <div className={`text-[16px] font-semibold transition-colors duration-200 ${
        isDark ? 'text-white' : 'text-[#072837]'
      }`}>
        Sending to Postal recipients only
      </div>

      {content}
    </div>
  );
};

export default PostalOnlySection;
